// extracted by mini-css-extract-plugin
module.exports = {"keyword":"Keyword-module--keyword--JSc9s"};